import MainLayout from "../components/layouts/MainLayout";
import Container from "../components/Container";
import Title from "../components/Title";
import Typo from "../components/Typo";
import CookieGroup from "../components/CookieGroup";
import Button from "../components/Button";
import Router, { useRouter } from 'next/router'
import { useState } from "react";
import { getCookiePreferences, setCookiePreferences } from "../helpers/cookies";
import localized from "../locale/locales";
import { cookieGroups } from "../helpers/content";
import Head from "next/head";

export default function CookieSettings({ hasCookiePreferences, cookiePreferences }) {
    const { locale } = useRouter();
    const lang = localized[locale].cookies;

    const [data, setData] = useState({
        required: 'granted',
        analytics_storage: hasCookiePreferences && cookiePreferences.analytics_storage ? 'granted' : 'denied',
        ad_storage: hasCookiePreferences && cookiePreferences.ad_storage ? 'granted' : 'denied',
    });

    const handleSubmit = (e) => {
        e.preventDefault();

        // save cookie
        setCookiePreferences(data);
    };

    return (
        <MainLayout
            hasCookiePreferences={hasCookiePreferences}
            cookiePreferences={cookiePreferences}
            title={lang.title}
        >
            <Head>
                <meta name="robots" content="noindex" />
            </Head>
            <Container className="pt-32 pb-20">
                <section className="max-w-xl mx-auto">
                    <header className="text-center mb-8">
                        <Title className="mb-4">{lang.title}</Title>
                        <Typo>{lang.body}</Typo>
                    </header>

                    <div className="flex flex-col gap-6">
                        {cookieGroups.map((item, key) => {
                            return (
                                <CookieGroup {...item}
                                    key={`CookieGroup: ${key}`}
                                    onChange={({ target }) => {
                                        if (!item.disabled) {
                                            setData({
                                                ...data,
                                                [target.name]: target.checked ? 'granted' : 'denied'
                                            })
                                        }
                                    }}
                                    defaultChecked={data[item.name] === 'granted' || item.disabled}
                                />
                            )
                        })}
                    </div>
                    <div className="text-center mt-16">
                        <Button label={lang.cta} onClick={handleSubmit} />
                    </div>
                </section>
            </Container>
        </MainLayout>
    )
}

export async function getServerSideProps({ req, res }) {
    const cookiePreferences = getCookiePreferences(req);

    return {
        props: {
            ...cookiePreferences
        }
    }
}
